import { FormattedMessage, injectIntl } from 'react-intl';
import React from 'react';
import { resCodeMsg } from '@/components/resCodeMsg';
import { Row, Col, Button, Modal } from 'antd';
import { paymentPayflow, paymentJaPayflow } from '@/components/H5PC/service';
import { getPaymentType, getUrlParams, getUrlPrefix, gtag, sessionStorage } from '@/utils/index';
const { confirm } = Modal;

/**
 * 提取公用的提交方法
 * @param props
 * @param key
 * @param paramsEncrypted
 * @returns {Promise<any>}
 * @constructor
 */
export async function CommonHandleSubmit(
  props,
  key,
  paramsEncrypted,
  resData,
  setLoading,
  isMobileView,
  type,
) {
  // console.log('isMobileView', isMobileView);
  // console.log(setLoading);
  // return;
  // orderId 初始化orderId
  const orderId = resData && resData.orderId;
  const intl = props.intl;
  const { formatMessage } = intl;
  // 少传一个props
  function CodeMsg(code) {
    return resCodeMsg(props, code);
  }
  const urlPrefix = getUrlPrefix();

  let res = {};
  // 请求
  if (type === 'offline') {
    res = await paymentJaPayflow(type, key, paramsEncrypted);
  } else {
    res = await paymentPayflow(type, key, paramsEncrypted);
  }

  /**
   * 不跳转逻辑梳理 409010、409012、409013、409014、600004、600005、600008、600009、900000、980000、990000、
   * 重新传单逻辑 403005、409015
   * 重新刷新页面逻辑 600000（key无效页面跳转无效页面）、600001、600002
   *
   *  code 为 409010，409013，403005 -- 跳转到 cancelUrl，需要重新发起创单
   *  code 为 409012 -- 支付失败，跳转到失败页
   *  code 为 409014 -- 卡余额不足，允许用户修改信息再次发起支付
   *  code 为 600000 -- Key 无效
   *  code 为 600001 -- token 无效，提示页面已失效，重新调用初始化，刷新 token 和公钥
   *  code 为 600002 -- RSA 验证无效，重新调用初始化，刷新token和公钥
   *  code 为 600005 -- 短信验证失败
   *  code 为 900000，980000 -- 提示系统繁忙
   *  code 为 990000，409015 -- 按支付失败处理
   */
  // 如果后端挂了,关闭
  if (!res) {
    setLoading(false);
    return;
  }

  // const orderId = res && res.data && res.data.orderId;
  // 成功
  if (res.code === 200000) {
    // // 清除refreshTimes的次数，使得跳出后跳回来也是第一次提醒错误
    // window.sessionStorage.removeItem('refreshTimes');
    // // 清除新增卡标记
    // // process.client && window.sessionStorage.removeItem('addNewCard');
    // //todo 判断3ds页面和非3ds页面逻辑区别
    // const tdsKey = res.data.tdsKey;
    // const tdsInfo = res.data.tdsInfo || {};
    // const { nextStep, url } = tdsInfo;
    // let validateKey = res?.data?.validateKey;
    // // console.log('tdskey',tdsKey);
    // if (tdsKey) {
    //   if (nextStep === 'DEVICE') {
    //     // 提交设备指纹iframe表单;
    //     submitForm();
    //     fetchDeviceFingerPrint();
    //     // 轮询
    //   } else if (nextStep === 'CHALLENGE') {
    //     window.location.href = `/3ds?tdsKey=${tdsKey}`;
    //   } else if (nextStep === 'DONE') {
    //     window.location.href = url;
    //   }
    // } else if (validateKey) {
    // } else {
    //   const redirectUrl = res.data.redirectUrl;
    //   const invoiceId = res.data.invoiceId;
    //   // 如果是oxo的支付方式，就直接跳到华为云支付页面
    //   // 特殊的支付方式封装
    //   paySuccussHref(redirectUrl, invoiceId, resData, type, key, res);
    // }
    
    // 针对不同失败返回的declineCode需要提示
    if (res.data.paymentStatus === 'PF') { 
      res = {
        data: { ...res.data },
        code: res.data.declineCode
      }
      CommonError(props, isMobileView, setLoading, res);
    }
  }
  if (res.code !== 200000) {
    CommonError(props, isMobileView, setLoading, res);
  }

  return res;
}
// 共同的错误提取
export function CommonError(props, isMobileView, setLoading, res, cancelUrl) {
  const intl = props.intl;
  const { formatMessage } = intl;
  // 少传一个props
  gtag('支付页面', [new Date() + CodeMsg(res.code)]);
  gtag('支付页面', ['支付发生失败']);

  gtag('支付页面', [CodeMsg(res.code)]);

  function CodeMsg(code) {
    return resCodeMsg(props, code);
  }
  const invoiceId = res.data && res.data.invoiceId || '';
  const content = (
    <div>
      {CodeMsg(res.code || '990000')}
      {/* <br />
      {orderId ? 'orderId:' + orderId : ''} */}
      <br />
      {invoiceId ? (
        <span
          style={{
            color: '#999',
            fontSize: '14px',
            display: 'block',
            marginTop: '8px',
          }}
        >
          invoiceId: {invoiceId}
        </span>
      ) : (
        ''
      )}
    </div>
  );
  if (res.code === 600010) {
    //  失败，跳转到商户（data.redirectUrl)
    if (res.data.redirectUrl.indexOf('http') > -1) {
      window.location.href = res.data.redirectUrl;
    } else {
      window.location.href = `${urlPrefix}${res.data.redirectUrl}`;
    }
  } else if (
    res.code === 403005 ||
    res.code === 409013 ||
    res.code === 409015
  ) {
    // 409010，409013，403005 -- 跳转到 cancelUrl，需要重新发起创单
    Modal.warning({
      width: isMobileView ? '80%' : '500px',
      centered: true,
      content: content,
      className: isMobileView ? 'h5pc-cashier-error_modal' : '',
      // okText: 'Got It',
      okText: formatMessage({ id: 'ga-checkout.got-it' }),
      onOk() {
        setLoading(false);
        return new Promise((resolve, reject) => {
          if (resData.cancelUrl) {
            window.location.href = resData.cancelUrl;
          } else {
            // 由于首页后端接口调整，取消此跳转逻辑
            window.location.href = `/?key=${key}`;
            window.location.reload();
          }
        }).catch(() => console.log('error!'));
      },
    });
  } else if (res.code === 409014) {
    // 余额不足
    Modal.warning({
      width: isMobileView ? '80%' : '500px',
      centered: true,
      content: content,
      className: isMobileView ? 'h5pc-cashier-error_modal' : '',
      // okText: 'Got It',
      okText: formatMessage({ id: 'ga-checkout.got-it' }),
      onOk() {
        return new Promise((resolve, reject) => {
          setLoading(false);
          setTimeout(Math.random() > 0.5 ? resolve : reject, 500);
        }).catch(() => console.log('error!'));
      },
    });
  } else if (
    res.code === 403001 ||
    res.code === 403006 ||
    res.code === 409010 ||
    res.code === 409011 ||
    res.code === 409012 ||
    // Evonet 不支持币种 
    res.code === 409123 ||
    res.code === 600004 ||
    res.code === 600008 ||
    res.code === 600009 ||
    //res.code === 600005 || 后面要特殊处理特殊提示文案
    res.code === 900000 ||
    res.code === 980000 ||
    res.code === 990000
  ) {
    Modal.warning({
      width: isMobileView ? '80%' : '500px',
      centered: true,
      // content: CodeMsg(res.code),
      content: content,
      className: isMobileView ? 'h5pc-cashier-error_modal' : '',
      // okText: 'Got It',
      okText: formatMessage({ id: 'ga-checkout.got-it' }),
      onOk() {
        return new Promise((resolve, reject) => {
          setLoading(false);
          setTimeout(Math.random() > 0.5 ? resolve : reject, 500);
        }).catch(() => console.log('error!'));
      },
    });
  } else if (res.code === 600005) {
    // 短信验证失败
    Modal.warning({
      width: isMobileView ? '80%' : '500px',
      centered: true,
      className: isMobileView ? 'h5pc-cashier-error_modal' : '',
      content: `${CodeMsg(res.code)} ${formatMessage({
        id: 'ga-checkout.remaining-verifications-times',
      })} ${res.data.authRemainFailNum}`,
      // okText: 'Got It',
      okText: formatMessage({ id: 'ga-checkout.got-it' }),
      onOk() {
        return new Promise((resolve, reject) => {
          setLoading(false);
          setTimeout(Math.random() > 0.5 ? resolve : reject, 500);
        }).catch(() => console.log('error!'));
      },
    });
  } else if (res.code === 600000) {
    // 页面失效
    Modal.warning({
      width: isMobileView ? '80%' : '500px',
      centered: true,
      className: isMobileView ? 'h5pc-cashier-error_modal' : '',
      // content: CodeMsg(res.code),
      content: content,
      // okText: 'Got It',
      okText: formatMessage({ id: 'ga-checkout.got-it' }),
      onOk() {
        return new Promise((resolve, reject) => {
          setLoading(false);
          window.location.reload();
        }).catch(() => console.log('error!'));
      },
    });
  } else if (res.code === 600001 || res.code === 600002) {
    // 签名过期
  } else if (res.code === 401005) { 
    console.log(props, res);
    // 页面referrer配置问题或直接打开页面
    Modal.warning({
      width: isMobileView ? '80%' : '500px',
      centered: true,
      className: isMobileView ? 'h5pc-cashier-error_modal' : '',
      // content: CodeMsg(res.code),
      content: content,
      // okText: 'Got It',
      okText: formatMessage({ id: 'ga-checkout.got-it' }),
      onOk() {
        return new Promise((resolve, reject) => {
          setLoading(false);
          window.location.href = cancelUrl;
        }).catch(() => console.log('error!'));
      },
    });
  } else if (res.code === 200100) { 
    // 重复支付
    Modal.warning({
      width: isMobileView ? '80%' : '500px',
      centered: true,
      className: isMobileView ? 'h5pc-cashier-error_modal' : '',
      // content: CodeMsg(990000),
      content: content,
      // okText: 'Got It',
      okText: formatMessage({ id: 'ga-checkout.got-it' }),
      onOk() {
        return new Promise((resolve, reject) => {
          setLoading(false);
          window.location.href = '/success?errorCode=200100'
        }).catch(() => console.log('error!'));
      },
    });
  } else {
    Modal.warning({
      width: isMobileView ? '80%' : '500px',
      centered: true,
      className: isMobileView ? 'h5pc-cashier-error_modal' : '',
      // content: CodeMsg(990000),
      content: content,
      // okText: 'Got It',
      okText: formatMessage({ id: 'ga-checkout.got-it' }),
      onOk() {
        return new Promise((resolve, reject) => {
          // setLoading(false);
          window.location.reload();
        }).catch((res) => console.log('error!', res));
      },
    });
  }
}


// 共同的错误提取
export function inPaymentRedirect(props, isMobileView, setLoading, res, cancelUrl) {
  const intl = props.intl;
  const { formatMessage } = intl;
  // 少传一个props
  gtag('支付页面', [new Date() + CodeMsg(res.code)]);
  gtag('支付页面', ['支付发生失败']);

  gtag('支付页面', [CodeMsg(res.code)]);

  console.log(res)

  function CodeMsg(code) {
    return resCodeMsg(props, code);
  }
  const invoiceId = res && res.invoiceId;
  const content = (
    <div>
      {CodeMsg(res.code || '990000')}
      {/* <br />
      {orderId ? 'orderId:' + orderId : ''} */}
      <br />
      {invoiceId ? (
        <span
          style={{
            color: '#999',
            fontSize: '14px',
            display: 'block',
            marginTop: '8px',
          }}
        >
          invoiceId: {invoiceId}
        </span>
      ) : (
        ''
      )}
    </div>
  );
  if (res.code) { 
    // 页面referrer配置问题或直接打开页面
    Modal.warning({
      width: isMobileView ? '80%' : '500px',
      centered: true,
      className: isMobileView ? 'h5pc-cashier-error_modal' : '',
      // content: CodeMsg(res.code),
      content: content,
      // okText: 'Got It',
      okText: formatMessage({ id: 'ga-checkout.got-it' }),
      onOk() {
        return new Promise((resolve, reject) => {
          setLoading(false);
          window.location.href = res.returnUrl;
        }).catch(() => console.log('error!'));
      },
    });
  } else {
    Modal.warning({
      width: isMobileView ? '80%' : '500px',
      centered: true,
      className: isMobileView ? 'h5pc-cashier-error_modal' : '',
      // content: CodeMsg(990000),
      content: content,
      // okText: 'Got It',
      okText: formatMessage({ id: 'ga-checkout.got-it' }),
      onOk() {
        return new Promise((resolve, reject) => {
          setLoading(false);
          window.location.href = res.returnUrl;
        }).catch(() => console.log('error!'));
      },
    });
  }
}

/**
 * 取消支付
 * 跳转到商户页面
 *
 */
export function CommonHandleCancelPayment(
  props,
  resData,
  key,
  isMobileView,
  showDomain,
) {
  gtag(`${showDomain || ''}支付页面`, [new Date() + '点击取消支付']);
  gtag(`${showDomain || ''}支付页面`, [ '点击取消支付']);
  const intl = props.intl;
  const { formatMessage } = intl;
  const h5OrWeb = isMobileView ? 'H5' : 'WEB';
  confirm({
    width: isMobileView ? '80%' : '500px',
    centered: true,
    // title: 'Cancel payment',
    title: formatMessage({ id: 'ga-checkout.cancel-payment' }),
    // content: 'Your order is almost complete, Still cancel this payment?',
    content: formatMessage({ id: 'ga-checkout.still-cancel' }),
    // okText: 'Cancel Payment',
    okText: formatMessage({ id: 'ga-checkout.cancel-payment' }),
    // cancelText: 'Not Now',
    cancelText: formatMessage({ id: 'ga-checkout.not-now' }),
    className: isMobileView
      ? 'h5pc-cashier-confirm_modal'
      : 'cashier-confirm_modal',
    onOk() {
      // todo @埋点
      gtag(`${showDomain || ''}支付页面`, [new Date() + '确认取消支付']);
      gtag(`${showDomain || ''}支付页面`, [ '确认取消支付']);
      if (resData?.cancelUrl) {
        window.location.href = resData.cancelUrl;
      } else {
        // 由于首页后端接口调整，取消此跳转逻辑
        // window.location.href = `/?key=${key}`;
        window.location.reload();
      }
    },
    onCancel() {
      // todo @埋点
      gtag(`${showDomain || ''}支付页面`, [new Date() + '不取消支付']);
      gtag(`${showDomain || ''}支付页面`, [ '不取消支付']);
    },
  });
}

/**
 * 支付成功逻辑跳转封装
 */

export function paySuccussHref(
  redirectUrl,
  invoiceId,
  resData,
  type,
  key,
  res,
) {
  const orderId = resData && resData.orderId;
  const cancelUrl = resData && resData.cancelUrl;
  const merchantSourceType = resData && resData.merchantSourceType;
  const paymentStatus = res && res.data.paymentStatus;
  const urlPrefix = getUrlPrefix();
  if (getPaymentType() === 'oxo') {
    let url = '';
    if (redirectUrl && redirectUrl.indexOf('http') > -1) {
      url = redirectUrl;
    } else {
      url = `${urlPrefix}${redirectUrl}`;
    }
    window.location.href = url;
  } else {
    // 原有逻辑
    // 跳到自己的成功页面
    // window.sessionStorage.setItem(
    //   'successRedirectUrl',
    //   res.data.redirectUrl,
    // );
    // 巴西特别逻辑判断
    if (type === 'pix') {
      const { barCode } = res?.data;
      window.location.href = `/br-pix?key=${key}&barCode=${barCode}&merchantSourceType=${merchantSourceType}&cancelUrl=${encodeURIComponent(cancelUrl)}&redirectUrl=${encodeURIComponent(redirectUrl)}`;
    } else if (type === 'bol') {
      window.location.href = `/br-boleto?key=${key}`;
    } else {

      if (paymentStatus === 'PS') {
        window.location.href = redirectUrl
      }else{
        redirectUrlFn(redirectUrl);
      }
    }
  }
}

const redirectUrlFn = redirectUrl => {
  const urlPrefix = getUrlPrefix();
  if (redirectUrl) {
    if (redirectUrl.indexOf('http') > -1) {
      window.location.href = redirectUrl;
    } else {
      window.location.href = `${urlPrefix}${redirectUrl}`;
    }
  }
};
/**
 * 判断支付成功失败
 */

export function CommonJudgePaymentStatus(props, resData, isMobileView) {
  function CodeMsg(code) {
    return resCodeMsg(props, code);
  }
  // orderId 初始化orderId
  const orderId = resData && resData.orderId;
  const invoiceId = resData && resData.invoiceId;
  const intl = props.intl;
  const { formatMessage } = intl;
  // 判断该笔订单是否支付失败，如果是支付失败的订单，出现弹窗提示
  // 使用场景：用户支付失败弹出失败弹窗，用户不进行正常下一步操作直接刷新页面，此时订单状态为支付失败，需要用户手动触发跳回到商户页面（cancelUrl）
  // 订单有错误码的时候，会返回lastResponseCode字段，其他情况此字段不返回
  // 如果是从选择支付方式也没看来的话，不提示最后报错信息
  const referrer = document.referrer;
  if (referrer.indexOf('/?') > -1) {
    return;
  }

  if (resData && resData.lastResponseCode) {
    let lastCode = resData.lastResponseCode;
    // const content = (
    //   <div>
    //     {CodeMsg(lastCode)}
    //     <br />
    //     {orderId}
    //   </div>
    // );
    const content = (
      <div>
        {CodeMsg(lastCode)}
        {/* <br />
        {orderId ? 'orderId:' + orderId : ''} */}
        <br />
        {invoiceId ? (
          <span
            style={{
              color: '#999',
              fontSize: '14px',
              display: 'block',
              marginTop: '8px',
            }}
          >
            invoiceId: {invoiceId}
          </span>
        ) : (
          ''
        )}
      </div>
    );
    if (
      lastCode === 403005 || // 金额超限
      lastCode === 409013 || // 支付被拒
      lastCode === 409014 || // 余额不足
      lastCode === 409015 // 支付超时
    ) {
      // 统一跳转，不需要其他跳转
      Modal.warning({
        width: isMobileView ? '80%' : '500px',
        centered: true,
        content: content, // 失败原因
        className: isMobileView ? 'h5pc-cashier-error_modal' : '',
        // okText: 'Got It',
        okText: formatMessage({ id: 'ga-checkout.got-it' }),
        onOk() {},
      });
    } else {
      // 统一跳转，不需要其他跳转
      Modal.warning({
        width: isMobileView ? '80%' : '500px',
        centered: true,
        // content: CodeMsg(lastCode), // 失败原因
        content: content, // 失败原因
        className: isMobileView ? 'h5pc-cashier-error_modal' : '',
        // okText: 'Got It',
        okText: formatMessage({ id: 'ga-checkout.got-it' }),
        onOk() {},
      });
    }
  }
}

/**
 * 测试代码
 */

export function CommonTestCode(props) {
  const form = props.form;
  // 测试代码
  const onFill = () => {
    form.setFieldsValue({
      // cardBrand: 'mastercard',
      // cardNo: '4000000000000002',
      // cardNo: '5031755734530604',
      // expirationMonth: '11',
      // expirationYear: '2025',
      // cardCity: '杭州',
      // agreement: ['我已阅读并同意'],
      // agreement: 'checked',
      // cardNo: '4761739000091011',
      // cardCvv: '123',
      // cardExpirationMonth: '02',
      // cardExpirationYear: '2022',
      // cardExpiryDate: '02/22',
      // cardName: '程泽赫',
      // idNo: '330821199212054011',
      // phoneNumber: '15088619814',
      // cardCountry: 'BR',
      // cardLine1: 'lianlian',
      // cardLine2: 'house number',
      // cardDistrict: 'cardDistrict',
      // cardCity: 'city',
      // cardPostcode: '31001511',
      // cardState: 'ANHUI',
      // email: 'zhanghao003@lianlianpay.com',
      // cardHolderIdNo: '845.117.735-21',
      firstName: 'Test',
      lastName: 'Person-uk',
      email: 'customer@email.uk',
      cardLine1: 'New Burlington St',
      cardPostcode: 'W13 3BG',
      cardCity: 'London',
      cardCountry: 'GB',
      phoneNumber: '01895081461', 
    });
    props.handleAddressCountry(form.getFieldValue('cardCountry'));
  };
  return (
    <Row>
      <Col>
        <Button type="link" htmlType="button" onClick={onFill}>
          Fill form
        </Button>
      </Col>
    </Row>
  );
}
